import { render, staticRenderFns } from "./SearchResultListItem.vue?vue&type=template&id=6ef7d6fe"
import script from "./SearchResultListItem.vue?vue&type=script&lang=js"
export * from "./SearchResultListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports